<template>
  <div class="rooot" ref="html2PdfRef" id="html2PdfID">
    <div class="pdf-heading">Inspection Report</div>
    <!-- <div class="btnDiv">
      <button
        type="button"
        class="printBtn"
        @click="htmlToPdf"
        v-if="isPrinBtnVisible"
      >
        Print
      </button>
    </div> -->

    <div class="img-container">
      <!-- <img :src="getDeckImage" alt="image" /> -->
    </div>

    <!-- <div class="icode">
        Inspection Report: &nbsp; &nbsp;&nbsp;{{
          getInspectionDetailsList[0].inspectionCode
        }}
      </div> -->
    <!-- <div class="details title">Inspection <span> Detail</span></div> -->

    <div class="loopdiv" v-for="(inspection, index) in inspectionData" :key="inspection.inspectionCode + '-' + index">
      <div class="main-roww">
        <table class="details-table">
          <tbody>
            <tr>
              <td class="report" colspan="4">
                Inspection Report :
                {{ inspection.inspectionCode }}
              </td>
            </tr>
            <tr>
              <td>Inspection ID:</td>
              <td>
                {{ inspection.inspectionCode }}
              </td>

              <td>Inspection Date:</td>
              <td>
                {{ formatDate(inspection.inspectionDate) }}
              </td>
            </tr>

            <tr>
              <td>Ship:</td>
              <td>
                {{ inspection.shipName }}
              </td>

              <td>Deck:</td>
              <td>
                {{ inspection.deckName }}
              </td>
            </tr>

            <tr>
              <td>Voyage:</td>
              <td>
                {{ inspection.voyageName }}
              </td>

              <td>Voyage Condition:</td>
              <td>
                {{ inspection.voyageCondition }}
              </td>
            </tr>

            <tr>
              <td>Inspector:</td>
              <td>
                {{ inspection.inspectorName }}
              </td>

              <td>Frame:</td>
              <td>
                {{ inspection.frameNumber + ' ' + inspection.frameSide }}
              </td>
            </tr>

            <tr>
              <td>Findings:</td>
              <td>
                {{ inspection.finding }}
              </td>
              <td>Zone:</td>
              <td>
                {{ inspection.zoneDeckName }}
              </td>
            </tr>

            <!-- <tr>
                <td>Inspection:</td>
                <td>
                  {{ inspection.inspectionCode }}
                </td>
              </tr> -->
            <tr>
              <td>Dimension Length::</td>
              <td>
                {{ inspection.length }}
              </td>

              <td>Dimension width::</td>
              <td>
                {{ inspection.width }}
              </td>
            </tr>
            <tr>
              <td>Severity:</td>
              <td>
                {{ inspection.severity }}
              </td>

              <td>Work Order:</td>
              <td>
                {{ inspection.workOrder }}
              </td>
            </tr>
            <tr>
              <td>Reinspection Date:</td>
              <td>
                {{ formatDate(inspection.reinspectionDate) }}
              </td>

              <td>Required &nbsp; &nbsp;&nbsp;Action &nbsp; &nbsp;&nbsp;Plan:</td>
              <td>
                {{ inspection.actionPlanRequired ? 'Yes' : 'No' }}
              </td>
            </tr>
            <tr></tr>
            <tr>
              <td>Comment:</td>
              <td>
                {{ inspection.summary }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import jsPDF from 'jspdf';
import {Utils} from '@/utils/Utils';
// import autoTable from 'jspdf-autotable';
import html2pdf from 'html2pdf.js';
import {mapGetters} from 'vuex';
@Component({
  computed: {
    ...mapGetters(['getInspectionDetailsList', 'getDeckImage']),
  },
})
export default class InspectionDetailsHTML extends Vue {
  @Prop({default: null}) deckImage;
  @Prop({default: null}) inspectionData;
  isPrinBtnVisible = true;
  // getInspectionDetailsList: any;
  // getDeckImage: any;
  // isPrinBtnVisible = true;
  //   @Prop({default: null}) deckImage!: String;
  //   @Prop({default: null}) inspectionData!: [];
  mounted() {
    //
  }

  formatDate(originalDate) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  /* eslint-disable */

  async htmlToPdf() {
    let filename = `${new Date().toLocaleString().split(',')[0].split('/').join('-')}`;
    const doc = new jsPDF('p', 'pt', 'A4');
    const htmlRef = this.$refs.html2PdfRef;

    doc.addImage(this.deckImage, 'JPEG', 10, 15, 570, 100, 'Image', 'FAST', 0); // eslint-disable-line
    // await doc.html(htmlRef);
    await doc.html(htmlRef, {
      x: 15, // eslint-disable-line
      y: 125,
      callback: function (doc) {
        doc.save('inspection-details-' + filename + '.pdf');
      },
    });

    this.$emit('stopLoader');

    // doc.table(15, 125, this.generateData(100), headers, { autoSize: true,printHeaders:false });
    // doc.save('inspection-details.pdf');

    // doc.text("Hello world!", 10, 10);
    // doc.addImage(this.deckImage, "JPEG", 15, 40, 180, 180,'image','FAST')
    // doc.save("a4.pdf");
  }
  /* eslint-enable*/
  async pdf() {
    this.isPrinBtnVisible = false;

    let filename = `${new Date().toLocaleString().split(',')[0]}`;

    await html2pdf(this.$refs.html2PdfRef, {
      margin: 0,
      filename: filename,
      image: {type: 'jpeg', quality: 0.98},
      html2canvas: {scale: 2},
      jsPDF: {unit: 'in', format: 'A4', orientation: 'portrait'},
    });
    //

    this.isPrinBtnVisible = true;
  }

  //   this.inspectionData.map((data: any) => {
  //     return {
  //      { displayLabel: 'Inspection ID',
  //       displayValue: data.inspectionCode},
  //     };
  //   });
  //
  // }
  //  async pdf() {
  //
}

//   async htmlToPdf() {
//     html2pdf().from("<h1>Title</h1>").save();
//

//     const doc = new jsPDF('p', 'pt', 'A4', true);
//
//     const htmlRef: any = this.$refs.html2Pdf as InnerHTML;
//

// doc.text("Hello world!", 10, 10);
// doc.addImage(this.deckImage, "JPEG", 15, 40, 180, 180,'image','FAST')
// doc.save("a4.pdf");

// await doc.html(htmlRef);
//

//

//     var string = doc.output('datauristring');
//
//     var embed = "<embed width='100%' height='100%' src='" + string + "'/>";
//     var x = await window.open();
//     x.document.open();
//     x.document.write(embed);
//     x.document.close();
//   }
</script>

<style scoped>
.rooot {
  padding-left: 5px;
  font-family: sans-serif;
  color: 'black';
  font-size: 8px;
  position: fixed;
  z-index: -1;
}

.pdf-heading {
  text-align: center !important;
  max-width: 335pt;
}

.report {
  text-align: center !important;
  max-width: 335pt;
}

table tbody td:nth-child(3n) {
  padding-left: 100px !important;
}
</style>
